import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenStorageService } from '../services/token-storage/token-storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthExpiredModalComponent } from '../shared-components/auth-expired-modal/auth-expired-modal.component';

export function QuizTimeApiInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const tokenStorage: TokenStorageService = inject(TokenStorageService);
  const modalService = inject(NgbModal);
  const token = tokenStorage.getToken();
  const isQuizTimeApiRequest = req.headers.has('X-QuizTimeApi');
  if (isQuizTimeApiRequest) {
    if (!token) {
      modalService.open(AuthExpiredModalComponent);
      return throwError(() => new Error('No token found'));
    }
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token?.access_token}`
      },
      headers: req.headers.delete('X-QuizTimeApi')
    });

    return next(cloned).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && isQuizTimeApiRequest) {
          // Clear the token as it's no longer valid
          tokenStorage.clear();
          modalService.open(AuthExpiredModalComponent);
        }
        return throwError(() => error);
      })
    );
  }

  return next(req);
}
